// One snapshot for every tab (Part B, 2026-09-25).
//
// Inbox, Pipeline, Live and the agent pill in the top bar all read the same
// `/pilotage` response, under one cache key — so the Inbox can never say
// « 3 need you » while the pill, fetched a moment later, says 4. The ✓ / ✗ /
// snooze mutations invalidate the `['pilotage']` prefix, which refreshes all.
import { useQuery } from '@tanstack/react-query';
import { pilotageApi } from '@/lib/api';

export const PILOTAGE_SNAPSHOT_KEY = ['pilotage', 'snapshot'] as const;

/** `everyMs` — the Live page asks every 8 s; everything else every 20 s. */
export function usePilotage(everyMs = 20_000) {
  return useQuery({
    queryKey: PILOTAGE_SNAPSHOT_KEY,
    queryFn: () => pilotageApi.snapshot(),
    refetchInterval: everyMs,
    // The pill sits on every tab; a background tab should not keep polling.
    refetchIntervalInBackground: false,
  });
}
